import { Controller } from 'stimulus'
import { useBusItem } from './mixins/useBusItem.js'
import { connectToParent, notifyUrlChange, updateBrowserUrl } from '@app/javascript/classes/iframe'

export default class extends Controller {
  static values = {
    url: String,
    shouldSync: Boolean,
    busItemId: String
  }

  connect() {
    useBusItem(this)

    if (this.shouldSyncValue) {
      this.updateBrowserUrl(this.urlValue)
    }
  }

  disconnect() {
    this.removeFromBus()
  }

  notifyClickToParent() {
    if (!this.isRenderedInIframe) return

    const connection = connectToParent()

    if (connection) {
      connection.promise.then((parent) => {
        parent.closeSearchFilter()
      })
    }
  }

  notifyClearToParent() {
    if (!this.isRenderedInIframe) return

    const connection = connectToParent()

    if (connection) {
      connection.promise.then((parent) => {
        parent.clearGlobalSearchBar()
      })
    }
  }

  // updates the URL on ember side
  notifyUrlChange(event) {
    if (!this.isRenderedInIframe) return

    notifyUrlChange(event.detail.newURL)
  }

  updateBrowserUrl(urlValue) {
    if (!this.isRenderedInIframe) return

    updateBrowserUrl(urlValue)
  }

  get isRenderedInIframe() {
    try {
      return window.self !== window.top
    } catch (_e) {
      return window.location !== window.parent.location
    }
  }
}
